<template>
  <div>
    <HeroSmall />
    <b-container class="mt-5 mb-5">
      <h1>Cookiebeleid</h1>
      <h3 class="pt-3">Cookies, of vergelijkbare technieken, die wij gebruiken</h3>
        <p>Stay.com gebruikt functionele, analytische en tracking cookies. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen in de browser van uw computer, tablet of smartphone. Stay.com gebruikt cookies met een puur technische functionaliteit. Deze zorgen ervoor dat de website naar behoren werkt en dat bijvoorbeeld uw voorkeursinstellingen onthouden worden. Deze cookies worden ook gebruikt om de website goed te laten werken en deze te kunnen optimaliseren. Daarnaast plaatsen we cookies die uw surfgedrag bijhouden zodat we op maat gemaakte content en advertenties kunnen aanbieden.</p>
        <p>Bij uw eerste bezoek aan onze website hebben wij u al geïnformeerd over deze cookies en toestemming gevraagd voor het plaatsen ervan.</p>
        <p>U kunt zich afmelden voor cookies door uw internetbrowser zo in te stellen dat deze geen cookies meer opslaat. Daarnaast kunt u ook alle informatie die eerder is opgeslagen via de instellingen van uw browser verwijderen. Zie voor een toelichting: https://veiliginternetten.nl/themes/situatie/cookies-wat-zijn-het-en-wat-doe-ik-ermee/</p>
        <p>Op deze website worden ook cookies geplaatst door derden. Dit zijn bijvoorbeeld adverteerders en/of de sociale media-bedrijven. Hieronder een overzicht:</p>
        Cookie: Googly Analytics<br/>
        Naam: _utma<br/>
        Functie: Analytische cookie die websitebezoek meet<br/>
        Bewaartermijn: 2 jaar<br/><br/>
        <p>Wilt u meer weten over het privacybeleid? Bekijk dan ons <a href="/nl-nl/privacybeleid">Privacybeleid</a>.</p>
      </b-container>
  </div>
</template>

<script>
import HeroSmall from '@/components/ui/HeroSmall.vue'
export default {
  name: 'Cookies',
  components: {
    HeroSmall,
  }
}
</script>

<style scoped>

</style>